'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LocationFormValidator = undefined;
exports.locationValidator = locationValidator;

var _reactIntl = require('react-intl');

var _validators = require('validators');

var messages = (0, _reactIntl.defineMessages)({
  invalidLocation: {
    id: 'location-modal.validations.invalidLocation',
    defaultMessage: 'Please provide a valid location.'
  }
});

function locationValidator(loc) {
  if (loc && !(loc.lat && loc.lon && loc.name)) {
    return messages.invalidLocation;
  }
}

var LocationFormValidator = exports.LocationFormValidator = (0, _validators.composeValidators)((0, _validators.validateFields)(_validators.requiredValidator, ['location']), (0, _validators.validateFields)(locationValidator, ['location']));